import { Auth } from '~/amplify';

const getIsMFACompleted = async (): Promise<boolean> => {
  const mfaPreferences = await Auth.fetchMFAPreference();

  return (
    mfaPreferences.enabled !== undefined && mfaPreferences.enabled.length > 0
  );
};

export default getIsMFACompleted;
